// extracted by mini-css-extract-plugin
export var cancelButton = "_ps-5";
export var content = "_ps-3";
export var createButton = "_ps-6";
export var drawerContainer = "_ps-0";
export var footer = "_ps-2";
export var header = "_ps-1";
export var orderFormColumn = "_ps-4";